<template>
  <div>
    <div class="kt-login-v2__title">
      <h3>Verificatiecode invoeren</h3>
    </div>

    <form
      class="kt-login-v2__form kt-form"
      @submit.prevent
    >
      <input
        type="hidden"
        name="_token"
        :value="getMeta('csrf-token')"
      >

      <div
        v-if="authCodeInvalid"
        class="alert alert-bold alert-solid-danger alert-dismissible"
        role="alert"
      >
        <div class="alert-text">
          De ingevoerde verificatiecode is ongeldig.
        </div>
      </div>

      <div class="form-group">
        <input-text
          id="code"
          v-model="authCode"
          type="text"
          name="code"
          title="Authenticator Code"
          class="form-control"
          placeholder=""
          required
          autocomplete="false"
          inputmode="numeric"
          pattern="[0-9]*"
        />
      </div>

      <div class="form-group d-flex align-items-center">
        <input-checkbox
          v-model="rememberMe"
          label-class="p-0 m-0"
          tabindex="-1"
        />
        <span
          class="ml-2"
          @click="rememberMe = !rememberMe"
        >
          Vertrouw deze browser voor de komende 30 dagen
        </span>
      </div>

      <div class="kt-login-v2__actions mt-2 justify-content-end">
        <button
          type="submit"
          class="btn btn--primary"
          @click="submit"
        >
          Bevestigen
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import InputText from '@/components/input/InputText.vue'
import InputCheckbox from '@/components/input/Checkbox.vue'
import { getMeta } from '@/helpers/general'

const authStore = useAuthStore()

const {
  authCode,
  rememberMe,
  authCodeInvalid
} = storeToRefs(authStore)

const submit = async () => {
  if (!authCode.value) return

  authCodeInvalid.value = false

  await authStore.twoFactorChallenge()
    .then(() => {
      window.location.href = '/'
    })
    .catch((e) => {
      if (e?.response?.status === 422) {
        authCodeInvalid.value = true
      }

      console.error(e)
    })
}
</script>

<style scoped lang="scss">
#togglePassword {
  font-size: 1.15em !important;
}

.height-unset {
  height: unset;
}

.kt-input-icon__icon {
  pointer-events: unset !important;
}

#kt_login_form i {
  cursor: pointer;
}
</style>
